import { use } from 'react';

import { useTranslation } from 'react-i18next';

import { MultiPageDialog } from '~components';
import { StatusVariant } from '~enums';
import SelectedDevicesContext from '~features/devices/providers/selectedDevicesContext';

import SelectedDevicesOverview from '../forms/selectedDevicesOverview';

interface Props {
	open: boolean;
	loading: boolean;
	onClose: () => void;
	onFinish: () => void;
}

const DeviceMultiUnassignDialog = ({ open, loading, onClose, onFinish }: Props) => {
	const { t } = useTranslation();
	const selectedDevicesContext = use(SelectedDevicesContext);

	const title =
		selectedDevicesContext.singleDevice ?
			t('device.labels.unassignDeviceDialogTitle', { ns: 'entities' })
		:	t('device.labels.multiUnassignDialogTitle', { ns: 'entities' });

	return (
		<MultiPageDialog
			title={title}
			open={open}
			loading={loading}
			onClose={onClose}
			onFinish={onFinish}
			variant={StatusVariant.Destructive}
			pages={[
				{
					key: 'selectedDevices',
					content: (
						<SelectedDevicesOverview
							selectedDevices={
								selectedDevicesContext.singleDevice ?
									[selectedDevicesContext.singleDevice]
								:	selectedDevicesContext.selectedDevices
							}
							onRemoveClicked={selectedDevicesContext.removeDevice}
						/>
					),
				},
			]}
		/>
	);
};

export default DeviceMultiUnassignDialog;
